<template>
  <div class="playlist-inner flex items-center text-xs" :style="[customCss]">
    <div
      :style="[customCss]"
      class="playlist-bg-color flex py-10 pr-4 items-center text-xs pl-3 w-full"
      :class="isActive ? 'active-playlistVideo' : ''"
    ></div>
    <div class="w-full flex absolute pl-3" style="align-items: center">
      <span v-if="isActive" class="pr-4 playlist-icon-color">
        <i class="fa fa-play"></i>
      </span>
      <div v-else class="count pr-4 section-content-color">
        <slot name="tile-count"></slot>
      </div>
      <div class="cover-image w-20 h-10">
        <img
          v-if="thumbnail"
          class="w-full h-full object-cover rounded"
          :src="thumbnail"
          alt=""
        />
        <div
          v-else
          class="
            bg-light-grey
            text-white text-sm
            font-bold
            justify-center
            items-center
            flex
            w-20
            h-full
            rounded
            mr-4
          "
        ></div>
      </div>
      <div class="pl-3 label section-content-color inter-font-regular flex-1">
        <slot name="tile-name"></slot>
      </div>
      <div class="pl-3 lesson-check section-content-color">
        <slot name="tile-progress-status"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
export default {
  name: 'Tile',
  data() {
    return {
      thumbnail: null,
    };
  },
  props: {
    isActive: {
      required: true,
    },
    featuredImage: {
      default: () => {
        return '';
      },
    },
    featuredVideoSrc: {
      default: () => {
        return '';
      },
    },
    featuredVideoEmbed: {
      default: () => {
        return '';
      },
    },
    bannerSettings: {
      required: true,
    },
    getThemeSettings: {},
  },
  methods: {
    async loadThumbnail() {
      try {
        var doc = new DOMParser().parseFromString(
          this.featuredVideoEmbed,
          'text/html'
        );

        let str = doc.all[3];
        let id = str.getAttribute('id');
        let permalink = str.getAttribute('permalink');

        const videoData = await api.get(
          `${window.config.apiCoreUrl}/groovevideo/fetch-with-permalink?permalink=${permalink}&id=${id}`
        );

        return videoData.data.thumbnail;
      } catch (err) {
        /** */
      }
    },
  },
  async mounted() {
    if (this.bannerType === 'image') {
      this.thumbnail = this.featuredImage;
    } else if (this.bannerType === 'video') {
      this.thumbnail = await this.loadThumbnail();
    }
  },
  computed: {
    bannerType() {
      if (this.bannerSettings.hasOwnProperty('banner_type')) {
        return this.bannerSettings.banner_type;
      }

      return 'image';
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-tile-bg-color':
          this.themeSettings.body_section.tile_bg_color,
        '--template-section-content-color':
          this.themeSettings.configuration_options.section_content_color,
        '--template-playlist-bg-color':
          this.themeSettings.configuration_options.playlist_bg_color,
        '--template-playlist-icon-color':
          this.themeSettings.progressbar_section.complete_bar_color,
      };
    },
  },
};
</script>
<style lang="scss">
.active-playlistVideo {
  opacity: 0.8;
  position: relative;
  //   &:before {
  //     content: '';
  //  //   background-image: url("data:image/svg+xml,%3Csvg width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717964L12 7Z' fill='%23EC745F'/%3E%3C/svg%3E%0A");
  //     background-size: 15px 16px !important;
  //     width: 15px;
  //     position: absolute;
  //     height: 16px;
  //     left: 11px;
  //     top: 0px;
  //     bottom: 0px;
  //     margin: auto;
  //     background-color: transparent;
  //   }
}
.playlist-inner {
  position: relative;
  .cover-image {
    &.h-10 {
      height: 2.8rem;
    }
  }
  .lesson-check {
    position: absolute;
    right: 16px;
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
.tile-bg-color {
  background-color: var(--template-tile-bg-color);
}
.playlist-bg-color {
  background-color: var(--template-playlist-bg-color);
}
.section-content-color {
  color: var(--template-section-content-color);
}
.playlist-icon-color {
  color: var(--template-playlist-icon-color);
}
</style>